export default __webpack_public_path__ + "static/media/Section.4dae3e70.jpg";